"use client";
import { bookAMeetingImages, bookAMeetingSteps } from "@/data/book-a-meeting.data";
import React from "react";
import DescriptionCards from "./DescriptionCards";
import Image from "next/image";
import BookMeetingLink from "@/components/shared/BookMeetingLink";
import SectionHeader from "@/components/shared/headers/SectionHeader";
import { useDict } from "@/components/providers/LocaleProvider";

const BookAMeeting = () => {
  const t = useDict();
  return (
    <section>
      <SectionHeader
        align="center"
        title={t.home.bookAMeeting.sectionTitle}
      />

      <section className="flex flex-col-reverse xl:flex-row py-10 gap-8 lg:gap-16">
        {/* left section */}
        <section className="flex-1 space-y-8 lg:space-y-16">
          <section className="space-y-4">
            {bookAMeetingSteps.map((step) => {
              const copy = t.home.bookAMeeting.steps[step.key];
              return (
                <DescriptionCards
                  key={step.id}
                  description={{
                    id: step.id,
                    icon: step.icon,
                    title: copy.title,
                    description: copy.description,
                  }}
                />
              );
            })}
          </section>

          <BookMeetingLink className="!w-11/12 max-lg:mx-auto lg:!w-60 lg:!ml-16  !rounded-full" />
        </section>

        {/* right section */}
        <section className="xl:w-[calc(50%-32px)] grid grid-cols-5 grid-rows-2 gap-4 md:gap-8 h-[300px] md:h-[500px]">
          <div className="col-span-2 group rounded-2xl overflow-hidden">
            <Image
              src={bookAMeetingImages.image1}
              alt={bookAMeetingImages.imageAlt1}
              width={500}
              height={500}
              className="w-full h-full object-cover object-center transition-transform duration-500 ease-out group-hover:scale-110"
            />
          </div>

          <div className="col-span-3 group rounded-2xl overflow-hidden">
            <Image
              src={bookAMeetingImages.image2}
              alt={bookAMeetingImages.imageAlt2}
              width={500}
              height={500}
              className="w-full h-full object-cover object-center transition-transform duration-500 ease-out group-hover:scale-110"
            />
          </div>

          <div className="col-span-3 group rounded-2xl overflow-hidden">
            <Image
              src={bookAMeetingImages.image3}
              alt={bookAMeetingImages.imageAlt3}
              width={500}
              height={500}
              className="w-full h-full object-cover object-center transition-transform duration-500 ease-out group-hover:scale-110"
            />
          </div>

          <div className="col-span-2 group rounded-2xl overflow-hidden">
            <Image
              src={bookAMeetingImages.image4}
              alt={bookAMeetingImages.imageAlt4}
              width={500}
              height={500}
              className="w-full h-full object-cover object-center transition-transform duration-500 ease-out group-hover:scale-110"
            />
          </div>
        </section>
      </section>
    </section>
  );
};

export default BookAMeeting;
